import React from 'react';
import { CustomBottomBar } from '@components';
import { Button, Container, Typography } from '@design-system';
import { MdKeyboardArrowRight } from 'react-icons/md';
import './CompanyChoicePage.scss';
import { useCompanyChoicePageVM } from './useCompanyChoicePageVM';

export const CompanyChoicePage: React.FC = () => {
    const { companies, selectedCompany, handleCompanySelect, handleContinue } = useCompanyChoicePageVM();

    return (
        <Container className="company-choice-page company-choice-page-custom-bottom-bar" height="fill">
            <Container center column padding="large" height="fill">
                <Typography intrinsic="p" color="marine">
                    Avant de démarrer,
                </Typography>

                <Typography intrinsic="h2" color="marine" className="mt-small-spacing">
                    Veuillez choisir votre secteur.
                </Typography>

                <div className="companies-container">
                    {companies.map((company) => (
                        <div
                            key={company.id}
                            className={`company-card ${selectedCompany?.id === company.id ? 'selected' : ''}`}
                            onClick={() => handleCompanySelect(company)}
                        >
                            <div className="company-logo-container">
                                <img src={company.logo} alt={`Logo ${company.name}`} className="company-logo" />
                            </div>
                        </div>
                    ))}
                </div>
            </Container>
            <CustomBottomBar className="company-choice-bottom-bar">
                <Button
                    onClick={handleContinue}
                    color="marine"
                    size="fullwidth"
                    icon={<MdKeyboardArrowRight />}
                    iconPosition="forced-right"
                    iconColor="white"
                    iconSize={25}
                    disabled={!selectedCompany}
                >
                    <Typography intrinsic="h4">Valider</Typography>
                </Button>
            </CustomBottomBar>
        </Container>
    );
};
